import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { vietnamProvinces } from '../utils/vietnamProvinces';

const PostItem = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    condition: '',
    location: '',
    image_url: ''
  });

  // Set default location from user's address when component mounts
  useEffect(() => {
    if (user && user.address) {
      setFormData(prev => ({
        ...prev,
        location: user.address
      }));
    }
  }, [user]);
  const [imagePreview, setImagePreview] = useState('');
  const [imageError, setImageError] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImageError('');
    if (!file.type.startsWith('image/')) {
      setImageError('Vui lòng chọn file hình ảnh');
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      setImageError('Kích thước file tối đa 5MB');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setFormData((prev) => ({ ...prev, image_url: dataUrl }));
      setImagePreview(typeof dataUrl === 'string' ? dataUrl : '');
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!formData.title) {
      setError('Vui lòng nhập tiêu đề');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/api/items', formData);
      setSuccess('Đăng món đồ thành công!');
      setTimeout(() => {
        navigate(`/item/${response.data.item.id}`);
      }, 1500);
    } catch (error) {
      setError(error.response?.data?.error || 'Đăng món đồ thất bại');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className="container" style={{ maxWidth: '700px', marginTop: '40px' }}>
      <div className="card">
        <h2 style={{ marginBottom: '24px', textAlign: 'center' }}>Đăng Món Đồ</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Tiêu đề *</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Ví dụ: Áo sơ mi nam size M"
              required
            />
          </div>
          <div className="form-group">
            <label>Mô tả</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Mô tả chi tiết về món đồ..."
            />
          </div>
          <div className="form-group">
            <label>Danh mục</label>
            <select name="category" value={formData.category} onChange={handleChange}>
              <option value="">Chọn danh mục</option>
              <option value="quan-ao">Quần áo</option>
              <option value="do-dung">Đồ dùng</option>
              <option value="sach">Sách</option>
              <option value="do-choi">Đồ chơi</option>
              <option value="noi-that">Nội thất</option>
              <option value="khac">Khác</option>
            </select>
          </div>
          <div className="form-group">
            <label>Tình trạng</label>
            <select name="condition" value={formData.condition} onChange={handleChange}>
              <option value="">Chọn tình trạng</option>
              <option value="moi">Mới</option>
              <option value="tot">Tốt</option>
              <option value="binh-thuong">Bình thường</option>
              <option value="cu">Cũ</option>
            </select>
          </div>
          <div className="form-group">
            <label>Tỉnh/Thành phố</label>
            <select name="location" value={formData.location} onChange={handleChange}>
              {vietnamProvinces.map(province => (
                <option key={province.value} value={province.value}>
                  {province.label}
                </option>
              ))}
            </select>
            <small style={{ color: '#666', fontSize: '14px' }}>
              {user?.address 
                ? `Đã tự động chọn theo thông tin đăng ký của bạn. Bạn có thể thay đổi nếu cần.`
                : 'Chọn tỉnh/thành phố nơi bạn đang ở để người khác dễ tìm thấy'}
            </small>
          </div>
          <div className="form-group">
            <label>Hình ảnh</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileSelect}
            />
            <small style={{ color: '#666', fontSize: '14px', display: 'block', marginTop: '6px' }}>
              Chọn ảnh từ máy (tối đa 5MB) hoặc nhập link hình bên dưới
            </small>
            {imageError && <div className="error" style={{ marginTop: '8px' }}>{imageError}</div>}
            {imagePreview && (
              <div style={{ marginTop: '12px' }}>
                <img
                  src={imagePreview}
                  alt="Xem trước"
                  style={{ width: '100%', maxHeight: '220px', objectFit: 'cover', borderRadius: '8px' }}
                />
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Link hình ảnh (URL)</label>
            <input
              type="url"
              name="image_url"
              value={formData.image_url}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
            />
            <small style={{ color: '#666', fontSize: '14px' }}>
              Bạn có thể dán link hình ảnh từ internet hoặc để trống
            </small>
          </div>
          {error && <div className="error">{error}</div>}
          {success && <div className="success">{success}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Đang đăng...' : 'Đăng Món Đồ'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PostItem;

